__turbopack_context__.v({
  "empty": "Empty-module-scss-module__iteB8W__empty",
  "empty__message": "Empty-module-scss-module__iteB8W__empty__message",
  "empty__pic": "Empty-module-scss-module__iteB8W__empty__pic",
});
